import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { UUID } from 'angular2-uuid';

import * as ɵngcc0 from '@angular/core';
class SimpleMQ {
    constructor() {
        this.mq = {};
        this.subscription = {};
    }
    getQueue() {
        return Object.keys(this.mq);
    }
    getSubscription() {
        return Object.keys(this.subscription);
    }
    newQueue(name) {
        if (name === undefined || this.mq[name]) {
            return false;
        }
        let s = new Subject();
        let o = s.asObservable();
        this.mq[name] = { subject: s, observable: o };
        return true;
    }
    delQueue(name) {
        if (name === undefined || !this.mq[name]) {
            return false;
        }
        let s = this.getSubscription();
        // unsubscribe all subscription for queue 'name'
        s.forEach(i => {
            if (this.subscription[i].name === name) {
                this.unsubscribe(i);
            }
        });
        // delete queue 'name' subject and observable
        delete this.mq[name].observable;
        delete this.mq[name].subject;
        delete this.mq[name];
    }
    publish(name, msg, lazy = true) {
        if (msg === undefined || name === undefined) {
            return false;
        }
        if (lazy) {
            this.newQueue(name);
        }
        else if (!this.mq[name]) {
            return false;
        }
        this.mq[name].subject.next(msg);
        return true;
    }
    subscribe(name, callback, lazy = true) {
        if (name === undefined || callback === undefined) {
            return '';
        }
        if (lazy) {
            this.newQueue(name);
        }
        else if (!this.mq[name]) {
            return '';
        }
        let id = name + '-' + UUID.UUID();
        this.subscription[id] = {
            name: name,
            subscription: this.mq[name].observable.subscribe(callback)
        };
        return id;
    }
    unsubscribe(id) {
        if (id === undefined || !this.subscription[id]) {
            return false;
        }
        this.subscription[id].subscription.unsubscribe();
        delete this.subscription[id];
    }
}
SimpleMQ.ɵfac = function SimpleMQ_Factory(t) { return new (t || SimpleMQ)(); };
SimpleMQ.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: SimpleMQ, factory: SimpleMQ.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SimpleMQ, [{
        type: Injectable
    }], function () { return []; }, null); })();

/*
 * Public API Surface of ng2-simple-mq
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SimpleMQ };

//# sourceMappingURL=ng2-simple-mq.js.map